// AvailableUsersAPI.js

import Axios from "../../utils/axios";

export const getAvailableUsers = async () => {
  const response = await Axios.post("/availableusers", {});
  return response.data;
};
export const saveUserCircleAPI = async (data) => {
    const payload = {
      userAuthId: data.userAuthId,
      circlerequeststatus: data.circlerequeststatus,
    };
  
    if (data.rejectionnotes) {
      payload.rejectionnotes = data.rejectionnotes;
    }
  
    const response = await Axios.post("/usercircles/save", payload);
    return response.data;
  };
  
  export const getMyCircleRequestsAPI = async (payload = {}) => {
    const response = await Axios.post("/usercircles/mycirclerequests", payload);
    return response.data;
  };
  export const updateUserCircleAPI = async (data) => {
    const payload = {
      _id: data._id,
      userAuthId: data.userAuthId,
      circlerequeststatus: data.circlerequeststatus,
    };
  
    if (data.rejectionnotes) {
      payload.rejectionnotes = data.rejectionnotes;
    }
  
    const response = await Axios.post("/usercircles/update", payload);
    return response.data;
  };
  // AvailableUsersAPI.js

export const getMyCircleAPI = async (payload = {}) => {
    const response = await Axios.post("/usercircles/mycircle", payload);
    return response.data;
  };
  
  